// Tooth outlines for the slide drawings, in the side-view tooth space of the Oct 3 trial decks: 120 units wide,
// crown up, the gum near y 86 and the root tips near y 160. The first six are the trial's own shapes, verbatim.

/** A molar from the side: crown and both roots. */
export const TOOTH =
  "M22,78 C16,52 26,24 44,22 C52,21 56,30 60,30 C64,30 68,21 76,22 C94,24 104,52 98,78 " +
  "C96,100 92,128 84,156 C82,162 74,162 73,156 C70,138 66,112 60,104 C54,112 50,138 47,156 " +
  "C46,162 38,162 36,156 C28,128 24,100 22,78 Z";

/** The enamel above the cementoenamel junction. */
export const CROWN =
  "M22,78 C16,52 26,24 44,22 C52,21 56,30 60,30 C64,30 68,21 76,22 C94,24 104,52 98,78 C80,84 40,84 22,78 Z";

/** The pulp chamber and both canals. */
export const PULP =
  "M47,66 C47,56 53,52 60,54 C67,52 73,56 73,66 C73,76 70,84 68,94 C67,114 74,140 78,152 " +
  "L75,153 C69,140 63,116 61,100 L59,100 C57,116 51,140 45,153 L42,152 C46,140 53,114 52,94 " +
  "C50,84 47,76 47,66 Z";

/** The two canals as strokes (a root canal fills them). */
export const CANALS = "M52,92 C51,118 46,140 43,152 M68,92 C69,118 74,140 77,152";

/** The tooth shaped for a crown. */
export const STUMP =
  "M28,80 C27,64 30,48 37,40 C47,35 73,35 83,40 C90,48 93,64 92,80 C78,85 42,85 28,80 Z";

/** A crown's porcelain cap. */
export const CAP =
  "M18,80 C12,52 24,18 44,16 C52,15 56,25 60,25 C64,25 68,15 76,16 C96,18 108,52 102,80 " +
  "C82,88 38,88 18,80 Z";

// Where the root surface sits at a given height, for the gum pocket wedges.
export function rootLeftX(y: number): number {
  return 22 + ((y - 78) * 14) / 78;
}

export function rootRightX(y: number): number {
  return 98 - ((y - 78) * 14) / 78;
}

/** The empty socket a removed tooth leaves: the roots' outline below the gum line (y 90), open at the top. */
export const SOCKET_OUTLINE =
  "M96.8,90 C94.5,109.7 90.6,132.9 84,156 C82,162 74,162 73,156 C70,138 66,112 60,104 " +
  "C54,112 50,138 47,156 C46,162 38,162 36,156 C29.4,132.9 25.5,109.7 23.2,90";

// The molar prepared for an inlay or onlay: a box cut from cusp tip to cusp tip.
export const TOOTH_INLAY =
  "M22,78 C16,52 26,24 44,22 L45.4,41 C45.6,44.4 47.4,46 51,46 L69,46 C72.6,46 74.4,44.4 74.6,41 L76,22 " +
  "C94,24 104,52 98,78 C96,100 92,128 84,156 C82,162 74,162 73,156 C70,138 66,112 60,104 " +
  "C54,112 50,138 47,156 C46,162 38,162 36,156 C28,128 24,100 22,78 Z";

export const CROWN_INLAY =
  "M22,78 C16,52 26,24 44,22 L45.4,41 C45.6,44.4 47.4,46 51,46 L69,46 C72.6,46 74.4,44.4 74.6,41 L76,22 " +
  "C94,24 104,52 98,78 C80,84 40,84 22,78 Z";

/** The porcelain piece: the box plus the chewing surface it restores. */
export const INLAY =
  "M44,22 C52,21 56,30 60,30 C64,30 68,21 76,22 L74.6,41 C74.4,44.4 72.6,46 69,46 L51,46 " +
  "C47.4,46 45.6,44.4 45.4,41 Z";

/** Where the piece fits: the box's walls and floor. */
export const INLAY_FIT =
  "M44,22 L45.4,41 C45.6,44.4 47.4,46 51,46 L69,46 C72.6,46 74.4,44.4 74.6,41 L76,22";

// A front tooth from the side (its labial face on the right) and the veneer's shell.
export const INCISOR =
  "M55,15 C57.6,12.2 62.4,12.2 65,15 C72,30 79,56 80,84 C80,108 71,140 62,164 C60,168 58,168 57,164 " +
  "C48,140 40,110 40,84 C40,76 41,68 45,58 C49,48 52,30 55,15 Z";

export const INCISOR_CROWN =
  "M55,15 C57.6,12.2 62.4,12.2 65,15 C72,30 79,56 80,84 C67,89 52,89 40,84 C40,76 41,68 45,58 C49,48 52,30 55,15 Z";

export const INCISOR_PULP =
  "M60,36 C62,36 63.4,38.4 63.5,44 C64.2,72 63.6,104 61,156 L59,156 C57.2,104 56.4,72 56.9,44 " +
  "C57,38.4 58.2,36 60,36 Z";

/** The incisor's labial face, where the shell bonds. */
export const INCISOR_FACE = "M65,15 C72,30 79,56 80,84";

export const VENEER_SHELL =
  "M62.6,11.6 C65.4,9.8 68.8,10.6 70.2,13.6 C77.8,29.6 84.8,55.4 85.4,85 L79,86.6 " +
  "C78.4,57.4 71.6,31.6 64.6,16.2 C64.2,14.4 63.6,12.8 62.6,11.6 Z";
